<template>
  <span>
    <slot name="button" v-bind="{ onclick: toggle }">
      <b-button variant="primary" class="mr-1" size="xs" @click="toggle"><i
          class="fas fa-edit"></i>&nbsp;Edit</b-button>
    </slot>

    <b-modal @show="resetModal" @hidden="resetModal" ref="modal-container" v-model="modalShow" size="lg" :title="title"
      :static="true" :lazy="true" hide-footer>
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group v-if="!this.create" label="_ID" label-for="id-input">
          <b-form-input id="id-input" v-model="formValues.id" :state="null" autocomplete="off" disabled />
        </b-form-group>

        <b-form-group label="Key" label-for="key-input">
          <b-form-input id="key-input" v-model="formValues.key" v-validate="{ required: true, min: 3 }"
            :state="validateState('key-input')" aria-describedby="key-input-live-feedback" data-vv-name="key-input"
            data-vv-as="Key" autocomplete="off" :disabled="!formValues.isEditable" />
          <b-form-invalid-feedback id="key-input-live-feedback">
            {{ veeErrors.first('key-input') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="File upload to CDN" label-for="file-input" v-if="modeUploadCDN">
          <b-form-file id="file-input" ref="fileInput" v-model="fileUpload" aria-describedby="key-input-live-feedback"
            data-vv-name="file-input" data-vv-as="Key" autocomplete="off" />
          <b-form-invalid-feedback id="key-input-live-feedback">
            {{ veeErrors.first('key-input') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Type" label-for="type-input">
          <b-form-input id="type-input" type="number" v-model="formValues.type" v-validate="{ required: true }"
            :state="validateState('type-input')" aria-describedby="type-input-live-feedback" data-vv-name="type-input"
            data-vv-as="Type" autocomplete="off" :disabled="!formValues.isEditable" />
          <b-form-invalid-feedback id="type-input-live-feedback">
            {{ veeErrors.first('type-input') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Value" label-for="options-input">
          <v-jsoneditor ref="value-editor" v-model="formValues.value"
            :options="{ mode: formValues.isEditable ? 'code' : 'view', enableSort: false, enableTransform: false }"
            :plus="false" />
        </b-form-group>

        <b-form-input id="value-editor-error" v-model="valueEditorError" v-validate="{ is: '' }"
          :state="validateState('value-editor-error')" aria-describedby="value-editor-error-live-feedback"
          data-vv-name="value-editor-error" data-vv-as="Value" hidden autocomplete="off" />
        <b-form-invalid-feedback id="value-editor-error-live-feedback" v-if="veeErrors.first('value-editor-error')">
          {{ valueEditorError }}
        </b-form-invalid-feedback>

        <b-form-group label="Default logo" label-for="logoDefault-input"
          v-if="formValues.key === 'default_table_settings'">
          <div style="max-width: 200px" class="mb-2" v-if="formValues.value.logo">
            <b-img :src="cdnBackUrl + '/' + formValues.value.logo + '?t=' + Date.now()" fluid
              alt="pictureDefault"></b-img>
          </div>
          <b-form-file v-model="formValues.pictureDefault" no-drop placeholder="Choose a file here..." />
        </b-form-group>

      </form>

      <b-button class="mt-2 float-right" :disabled="!formValues.isEditable" variant="primary"
        @click="handleSubmit">Save</b-button>
    </b-modal>
  </span>
</template>

<script>
import { getRouteIcon, ROUTE_CONFIGS } from "../../utils/routerIcons";
import Multiselect from 'vue-multiselect';
import VJsoneditor from "v-jsoneditor/src/index";
import Vue from "vue";

export default {
  data() {
    return {
      fileUpload: null,
      modalShow: false,
      modeUploadCDN: false,
      formValues: this.getInitialValues(),
      valueEditorError: '',
    }
  },
  components: {
    Multiselect,
    VJsoneditor,
  },
  props: {
    create: Boolean,
    title: String,
    defaultValues: Object
  },
  watch: {
    fileUpload: {
      handler(newVal) {
        if (newVal) {
          this.fileUpload = newVal;
          this.$refs.fileInput.reset();
          this.uploadFile();
        }
      },
      deep: true,
    },
    formValues: {
      handler(newVal) {
        if (newVal.key === 'default_poster') {
          this.modeUploadCDN = true;
        } else {
          this.modeUploadCDN = false;
        }
      },
      deep: true,
    },
  },
  methods: {
    uploadFile() {
      const fd = new FormData();
      fd.append('type', 'default-poster-config');
      fd.append('directory', 'default-posters');

      fd.append('files_1', this.fileUpload);

      this
        .$http({
          url: '/api/v1/files/default-poster',
          method: 'POST',
          data: fd,
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          this.formValues.value = { value: '/default-poster-config/default-posters/' + res.data.file };
        })
        .catch((err) => {
          this.$toastr.e(err.response.data.error);
        })
    },
    getInitialValues() {
      return {
        id: null,
        key: null,
        type: null,
        value: {},
        isEditable: true,
        pictureDefault: null,
      };
    },
    setDefaults() {
      let initialValues = this.getInitialValues();

      for (let field in initialValues) {
        Vue.set(this.formValues, field, initialValues[field]);
      }

      if (this.defaultValues) {
        for (let field in this.defaultValues) {
          Vue.set(this.formValues, field, this.defaultValues[field]);
        }
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    resetModal() {
      this.setDefaults();
    },
    hideModal() {
      this.$refs['modal-container'].hide();
    },
    toggle() {
      this.modalShow = !this.modalShow;
    },

    handleSubmit() {
      try {
        this.$refs['value-editor'].editor.get();
        this.valueEditorError = '';
      } catch {
        this.valueEditorError = 'The Value must be a valid json string';
      }

      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }

        const fd = new FormData();
        if (this.formValues.pictureDefault) {
          fd.append('pictureDefault', this.formValues.pictureDefault);
        }
        fd.append('type', this.formValues.type);
        fd.append('id', this.formValues.id);
        fd.append('key', this.formValues.key);
        fd.append('value', JSON.stringify(this.formValues.value));
        fd.append('isEditable', this.formValues.isEditable);
        this
          .$http({
            url: this.create ? '/api/v1/config' : '/api/v1/config/' + this.formValues.id,
            data: fd,
            headers: { "Content-Type": "multipart/form-data" },
            method: 'POST',
          })
          .then(() => {
            setTimeout(() => {
              this.$emit('finish');
            }, 500);

            this.hideModal();
            this.$toastr.i('Success');
          })
          .catch((err) => {
            this.$toastr.e(JSON.stringify(err.response.data.message));

            throw err;
          });
      });
    },
  },
  computed: {
    routeIcon: () => getRouteIcon(ROUTE_CONFIGS),
    cdnBackUrl() {
      return process.env.VUE_APP_CDN_BACK_URL || "https://cdn-dev.alg4u.com/98";
    },
  },
  mounted() {
    this.setDefaults();
  },
}
</script>
